import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { HEADER_HEIGHT, SCRoutes } from 'src/config';
import { PageNotFound } from '../PageNotFound';
import { DashboardAgencies } from './agencies/DashboardAgencies';
import { DashboardHome } from './dashboardHome/DashboardHome';
import { DashboardOrganization } from './organization';

import BusinessIcon from '@mui/icons-material/Business';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
import { Link, useLocation } from 'react-router-dom';
import { Wrapper } from 'src/components/Screen';
import { DashboardUsers } from './users/DashboardUsers';

type Props = {
  testID?: string;
};

const drawerWidth = 240;

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  top: '64px',
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    boxSizing: 'border-box',
    marginTop: `${HEADER_HEIGHT}px`,
  },
}));

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
}));

const SideMenu = () => {
  const location = useLocation();

  const menuItems = [
    {
      text: 'Tableau de bord',
      icon: <DashboardIcon />,
      link: SCRoutes.dashboard.home,
    },
    {
      text: 'Agences',
      icon: <BusinessIcon />,
      link: SCRoutes.dashboard.agencies.home,
    },
    {
      text: 'Utilisateurs',
      icon: <PeopleIcon />,
      link: SCRoutes.dashboard.users.home,
    },
  ];

  return (
    <StyledDrawer variant="permanent">
      <List>
        {menuItems.map((item) => (
          <StyledLink to={item.link} key={item.text}>
            <ListItem selected={location.pathname === item.link}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          </StyledLink>
        ))}
      </List>
    </StyledDrawer>
  );
};

export const Dashboard: React.FC<Props> = ({ testID = 'Dashboard' }) => {
  return (
    <>
      <SideMenu />
      <Wrapper style={{ marginLeft: drawerWidth }} className="bg-white">
        <Switch>
          <Route component={DashboardHome} path={SCRoutes.dashboard.home} exact />
          <Route path={SCRoutes.dashboard.agencies.home} component={DashboardAgencies} />
          <Route path={SCRoutes.dashboard.users.home} component={DashboardUsers} />
          <Route path={SCRoutes.dashboard.organization.home} component={DashboardOrganization} />
          <Route component={PageNotFound} />
        </Switch>
      </Wrapper>
    </>
  );
};
